
/*Package importing*/
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

/*Components*/
import SelectBox from '../../components/formComponents/selectBox';
import Input from '../../components/formComponents/input';


/*Assets*/
import Deals from '../../assets/images/deals.png';


class Edit extends Component {
  constructor(props){
    super(props);
    this.state = {
      tabIndex: 1
    }
  }

  componentDidMount() {

  }

  tabItemClick(tempItem){
    this.setState({tabIndex: tempItem});
  }
  selectChange = async (category) => {
    await this.setState({category: category});
  }


  render() {

     const filterBy = [
      { value: 1, label: 'Active' },
      { value: 2, label: 'Ongoing' },
      { value: 3, label: 'Completed' },
    ]

    return (
      <div className="e-main-content e-vendor-table">
        <h2 className="e-page-head">Expired ads</h2>

            <div>
              <div className="row">
                <div className="col-lg-10">
                  <div className="e-vendor-category-list e-edit-ad">
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="e-ad-dotted-border e-deals-border e-edit-schedule-ad">
                          <img src={Deals} className="e-deals pb-4" alt="Offer Logo"/>
                          <Input id="" type="" className="e-deal-link" defaultValue={this.state.username} valueChange={(tempVal) => this.setState({username: tempVal})} placeholder="Add website link" />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="e-ad-dotted-border e-deals-border e-edit-schedule-ad">
                          <img src={Deals} className="e-deals pb-4" alt="Offer Logo"/>
                          <Input id="" type="" className="e-deal-link" defaultValue={this.state.username} valueChange={(tempVal) => this.setState({username: tempVal})} placeholder="Add website link" />
                        </div>
                      </div>
                    </div>
                    <div className="row pt-4 ml-1">
                      <Link className="e-btn-next" to="/slot">
                        <button className="e-s-btn" type="submit" value="Submit">Next</button>
                      </Link>

                    </div>
                  </div>
                </div>
              </div>

            </div>

      </div>

    );
  }
}

export default Edit;
